// extracted by css-extract-rspack-plugin
export default {"cls1":"AddToListButton-cls1_ZhH","cls2":"AddToListButton-cls2_WlY AddToListButton-cls1_ZhH"};